import { Icon } from '@chakra-ui/react';

export const CustomUnlockedLockMultiIcon = (props) => (
  <Icon viewBox="0 0 24 24" width="70px" height="70px" {...props}>
    <path
      d="M7,11V7c0-2.76,2.24-5,5-5s5,2.24,5,5c0,0.55-0.45,1-1,1s-1-0.45-1-1c0-1.66-1.34-3-3-3s-3,1.34-3,3v4h9
         c1.1,0,2,0.9,2,2v7c0,1.1-0.9,2-2,2H6c-1.1,0-2-0.9-2-2v-7c0-1.1,0.9-2,2-2H7z M12,16c-0.55,0-1,0.45-1,1s0.45,1,1,1s1-0.45,1-1
         S12.55,16,12,16z"
      className="multicolorElToDark darkBgElToWhite"
      fill="#FF4935"
    />
  </Icon>
);

export const CustomLockMultiIcon = (props) => (
  <Icon viewBox="0 0 24 24" width="70px" height="70px" {...props}>
    <path
      d="M7,11V7c0-2.76,2.24-5,5-5s5,2.24,5,5v4h1c1.1,0,2,0.9,2,2v7c0,1.1-0.9,2-2,2H6c-1.1,0-2-0.9-2-2v-7c0-1.1,0.9-2,2-2H7z
       M12,4c-1.66,0-3,1.34-3,3v4h6V7C15,5.34,13.66,4,12,4z M12,16c-0.55,0-1,0.45-1,1s0.45,1,1,1s1-0.45,1-1S12.55,16,12,16z"
      className="multicolorElToDark darkBgElToWhite"
      fill="#FF4935"
    />
  </Icon>
);
